import { Tooltip as ReactTooltip } from 'react-tooltip';
import { getTagLevel2Name, getTagLevel2PathLabel } from './TagsTree';
import styles from './TagChip.module.scss';

export const TagChip = ({ tag, className, variant = 'default' }) => {
  if (!tag) return null;
  const label = getTagLevel2Name(tag);
  const fullPath = getTagLevel2PathLabel(tag);
  const tooltipId = `tag-chip-${tag.id ?? tag.full_path.replace(/[^a-zA-Z0-9]/g, '-')}`;
  const baseClass = variant === 'compact' ? styles.tagChipCompact : styles.tagChip;
  return (
    <>
      <span
        className={className ? `${baseClass} ${className}` : baseClass}
        data-tooltip-id={tooltipId}
        data-tooltip-content={fullPath}
      >
        {label}
      </span>
      <ReactTooltip
        id={tooltipId}
        place="bottom"
        style={{ borderRadius: '6px', zIndex: 1000 }}
      />
    </>
  );
};
